import { Component, Input } from "@angular/core";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "../../../../../utils/pipes/pipes.module";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-course-item",
  imports: [SharedModule, PipesModule, NgbTooltipModule, TranslateModule],
  templateUrl: "./course-item.component.html",
  styleUrl: "./course-item.component.scss",
})
export class CourseItemComponent {
  @Input() data: any;

  fileUrl = environment.apiFileUrl;

  /** One decimal place. `number` is not available here — SharedModule imports
   *  CommonModule but does not re-export it. */
  ratingLabel(): string {
    return Number(this.data?.rating || 0).toFixed(1);
  }
}
